import { Box } from "@mui/material";
import {
  TAG_COLORS,
  TAG_ICONS,
} from "src/config/store/services/tags-api/types";
import { TagIcon } from "../tag-icon/tag-icon";
import { classes } from "./tag-chip.styles";

type Props = {
  color: keyof typeof TAG_COLORS;
  icon: TAG_ICONS;
};

export const TagChip = ({ color, icon }: Props) => {
  return (
    <Box
      sx={{
        ...classes.tag,
        backgroundColor: TAG_COLORS[color],
      }}
    >
      <TagIcon icon={icon} color="black" size={20} />
    </Box>
  );
};
